import { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DeviceService from "../../Services/DeviceService";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';

/**
 * Renders add device model pop up to create device model
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function AddDeviceModel(props) {

    //#region States

    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    //#endregion

    //#region Refs

    const makeRef = useRef();
    const modelRef = useRef();

    //#endregion

    function resetHandler() {
        modelRef.current.value = "";
        makeRef.current.value = "";
        setError("");
        setMessagePopup(false);
    }

    //#region Handle Submit

    /**
    * Calls device service to create device model
    * @param  {Event} event  User action (on submitting form)
    */
    function handleSubmit(event) {
        event.preventDefault();

        let DeviceModelDTO = {
            Make: ((makeRef.current.value === "") ? null : makeRef.current.value),
            Model: ((modelRef.current.value === "") ? null : modelRef.current.value),
        };

        DeviceService.CreateDeviceModel(DeviceModelDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage("Device model created sucessfully");
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Add Device Model</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={handleSubmit}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="Model" className="label">Model</label>
                            <div>
                                <input type="text" className="InputField" placeholder="-Text-" min="0" maxlength="30" ref={modelRef} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="Make" className="label">Make</label>
                            <div>
                                <input type="text" className="InputField" placeholder="-Text-" min="0" maxlength="30" ref={makeRef} required />
                            </div>
                        </div>
                    </div>

                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={resetHandler} >
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><AddIcon /></span>
                                <span className="primary-button-text">Add Device Model</span>
                            </button>
                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AddDeviceModel;
